import { AnyAction } from "redux";

export const RESET_REDUX_STATE = "RESET_REDUX_STATE"
export const DIAGRAM_UPDATE = "DIAGRAM_UPDATE"